<template>
    <div id="whatsapp-channel-detail">
        <div class="wrapper" v-if="channel">
            <div class="toolbar">
                <div class="left">
                    <IconButton :on-click="() => $router.push('/integrations/whatsapp-v2')">
                        <span class="material-icons"> chevron_left </span>
                    </IconButton>
                    <div class="icon-container">
                        <WhatsappIcon />
                    </div>
                    <div class="name">Whatsapp V2 Channel :{{ channel.name }}</div>
                </div>
                <div class="right" v-show="channel">
                    <a-button type="primary" @click="visible = true" :loading="loading">
                        {{ $t("wp.startChatWithAnyNo") }}
                    </a-button>
                    <a-button type="primary" @click="refreshChannel"> Refresh </a-button>
                    <a-button type="primary" @click="restartChannel" :disabled="!restartEnabled">
                        {{ $t("whatsappChannel.restartChannel") }}
                    </a-button>
                    <a-button type="danger" @click="deleteModal = true"
                        >{{ $t("whatsappChannel.deleteChannel") }}
                    </a-button>
                </div>
            </div>
            <div class="channel-content">
                <div class="left">
                    <SidebarChild
                        :items="menuItems"
                        :selected-item="type"
                        :focusActive="true"
                        @selected="(i) => (type = i.key)"
                    />
                </div>
                <div class="page-content" v-if="channel">
                    <div v-if="type === 'integration'">
                        <WhatsappWizard :channel="channel" @complated="() => (type = 'detail')" />
                    </div>
                    <div v-if="type === 'detail'">
                        <UpdateDetail v-model="channel" :show-visibility-config="false" />
                    </div>
                    <div v-if="type === 'visibility'">
                        <Visibility v-model="channel" />
                    </div>

                    <div v-if="type === 'all-contacts'">
                        <WhatsappContactList :channel="channel" :channel-id="channel._id" />
                    </div>
                    <div v-if="type === 'broadcast-requests'">
                        <BroadcastRequests :channel="channel" :changePage="changePage" />
                    </div>
                    <div v-if="type === 'customer-groups'">
                        <CustomerGroups :channel="channel" :changePage="changePage" :channel-id="channel._id" />
                    </div>
                    <div v-if="type === 'wallet'" style="padding: 10px">
                        <Wallet />
                    </div>
                </div>
            </div>
        </div>
        <a-modal
            v-model="deleteModal"
            icon="exclamation-circle"
            :title="$t('whatsappChannel.whatsappChannel')"
            @cancel="deleteModal = false"
        >
            <p>{{ $t("whatsappChannel.deleteWhatsappChannelDescription") }}</p>
            <template #footer>
                <a-button key="back" @click="deleteModal = false">
                    {{ $t("chatbotv2.dismiss") }}
                </a-button>
                <a-button key="submit" type="danger" @click="deleteWhatsappChannel">
                    {{ $t("chatbotv2.delete") }}
                </a-button>
            </template>
        </a-modal>

        <WhatsappStartChat
            v-if="channel"
            :visibleStartChat="visible"
            :show-alert-message="showAlertMessage"
            :channel-id="channel._id"
            :channel="channel"
            @modal-closed="visible = false"
        />
    </div>
</template>
<script>
import Vue from "vue";
import Numbers from "../WhatsappBusiness/detail/Numbers.vue";
import ChatInitiatorTemplate from "../WhatsappBusiness/detail/ChatInitiatorTemplate.vue";
import ChannelMenu from "./ChannelMenu.vue";
import IconButton from "../Settings/components/IconButton.vue";

import WhatsappContactList from "../IntegrationChannelsItem/WhatsappContactList.vue";
import WhatsappIcon from "../Chatbot/pages/integrations/svg/WhatsappIcon.vue";
import Visibility from "../WhatsappBusiness/detail/Visibility.vue";
import WhatsappV2ChannelMenuTypes from "./WhatsappV2ChannelMenuTypes";
import { mapActions, mapGetters, mapState } from "vuex";
import { sendSocketMessage } from "../../../utils/socketStream";
import VueCountryCode from "vue-country-code";
import log2 from "../../../utils/log2";
import UpdateDetail from "./UpdateDetail.vue";
import WhatsappWizard from "./update/WhatsappWizard.vue";
import ContactListV2 from "../WhatsappV1/ContactListV2.vue";
import BroadcastRequests from "../WhatsappBusiness/detail/broadcast/BroadcastRequests.vue";
import CustomerGroups from "../WhatsappBusiness/detail/broadcast/CustomerGroups.vue";
import Wallet from "../Settings/pages/general/Wallet.vue";
import WhatsappStartChat from "../IntegrationChannelsItem/WhatsappStartChat.vue";
import SidebarChild from "../../../components/Sidebar/SidebarChild.vue";
import { getOrUpdateFilters } from "../../../utils/persistenceStorage";
import ChatWatcher from "../../../ChatWatcher";

const log = log2("W2ChannelDetail.vue");
const filters = getOrUpdateFilters("whatsapp-v2-channel-detail");
export default Vue.extend({
    name: "W2ChannelDetail",
    components: {
        CustomerGroups,
        BroadcastRequests,
        WhatsappWizard,
        UpdateDetail,
        VueCountryCode,
        Numbers,
        ChatInitiatorTemplate,
        Visibility,
        ChannelMenu,
        IconButton,
        WhatsappIcon,
        ContactListV2,
        WhatsappContactList,
        Wallet,
        WhatsappStartChat,
        SidebarChild,
    },
    data() {
        const path = (_.last(this.$route.path.split("/")) || "detail").toLowerCase().trim();
        const selected = Object.values(WhatsappV2ChannelMenuTypes).find((x) => x.path === path);
        return {
            type: filters.type || "integration",
            currentTab: selected ? selected.id : "detail",
            loading: false,
            selectedChannelId: this.$route.params.id,
            deleteModal: false,
            channel: null,
            WhatsappChannelMenuTypes: WhatsappV2ChannelMenuTypes,
            visible: this.$route.query.action == "start-chat",
            confirmLoading: false,
            whatsappNumber: "",
            showAlertMessage: false,
            dialCode: "+90",
            restartEnabled: true,
            menuItems: [
                {
                    enabled: true,
                    key: "integration",
                    label: this.$t("multi_whatsapp_api.integration"),
                    icon: {
                        type: "material-icons",
                        name: "integration_instructions",
                    },
                },
                {
                    enabled: true,
                    key: "detail",
                    label: this.$t("multi_whatsapp_api.detail"),
                    icon: {
                        type: "material-icons",
                        name: "info",
                    },
                },
                {
                    enabled: true,
                    key: "visibility",
                    label: this.$t("multi_whatsapp_api.visibility"),
                    icon: {
                        type: "material-icons",
                        name: "visibility",
                    },
                },
                {
                    enabled: true,
                    key: "wallet",
                    label: this.$t("settings.wallet"),
                    icon: {
                        type: "material-icons",
                        name: "account_balance_wallet",
                    },
                },
                {
                    enabled: true,
                    key: "broadcast-requests",
                    label: this.$t("multi_whatsapp_api.broadcast_requests"),
                    icon: {
                        type: "material-icons",
                        name: "podcasts",
                    },
                },
                {
                    enabled: true,
                    key: "customer-groups",
                    label: this.$t("multi_whatsapp_api.customer_groups"),
                    icon: {
                        type: "material-icons",
                        name: "group_add",
                    },
                },
                {
                    enabled: true,
                    key: "all-contacts",
                    label: this.$t("multi_whatsapp_api.all_contacts"),
                    icon: {
                        type: "material-icons",
                        name: "contacts",
                    },
                },
            ],
        };
    },
    computed: {
        ...mapState({
            stories: (state) => state.CB.stories,
            userLastCountry: (state) => _.get(state.auth.user, "lastGeoLocation.country"),
            channels: (state) => state.channel.channels.filter((x) => x.type === "whatsapp-v2"),
            siteId: (state) => _.get(state.site.site, "_id"),
            user: (state) => state.auth.user,
            socketConnected: (state) => state.socketStatus.socket_connected,
            site: (state) => state.site.site,
        }),
        ...mapGetters({
            myActiveConversations: "chat/getMyActiveConversations",
        }),
    },
    methods: {
        ...mapActions({
            createChannel: "channel/createChannel",
            listChannels: "channel/listChannels",
            deleteChannel: "channel/deleteChannel",
            updateChannel: "channel/updateChannel",
        }),
        changePage(page) {
            this.currentTab = page;
        },
        restartChannel() {
            this.$dialog
                .confirm(this.$t("whatsappChannel.wantRestartChannel"), {
                    okText: this.$t("chatbotv2.yes"),
                    cancelText: this.$t("chatbotv2.no"),
                })
                .then(() => {
                    this.restartEnabled = false;
                    sendSocketMessage("whatsapp restart-channel-bot", {
                        channelId: this.channel._id,
                        siteId: this.siteId,
                    });
                    setTimeout(() => {
                        this.restartEnabled = true;
                    }, 5000);
                });
        },
        refreshChannel() {
            this.$dialog
                .confirm(`Are you sure you want to refresh the channel?`, {
                    okText: this.$t("chatbotv2.yes"),
                    cancelText: this.$t("chatbotv2.no"),
                })
                .then(() => {
                    sendSocketMessage("whatsapp v2-refresh-bot", {
                        channelId: this.channel._id,
                        siteId: this.siteId,
                    });
                    this.$message.success("Channel is refreshing");
                });
        },
        deleteWhatsappChannel() {
            const channel = this.channel;
            this.deleteChannel(channel._id).then(() => {
                this.$router.push("/integrations/whatsapp-v2");
            });
        },
        handleSave() {
            const isValid = true;
            if (isValid) {
                const payload = this.channel;
                this.loading = true;
                this.updateChannel(payload)
                    .then(() => {
                        this.listChannels();
                        this.$message.success("Channel updated successfully");
                        this.$emit("ok");
                    })
                    .catch((err) => {
                        console.error(err);
                        this.$message.error("Failed to update channel");
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        handleCancel() {
            this.visible = false;
            this.confirmLoading = false;
            this.whatsappNumber = "";
            this.showAlertMessage = false;
        },
        onSelect(value) {
            log("onSelect", value);
            this.dialCode = value.dialCode;
        },
        startChat(whatsappNumber) {
            if (!whatsappNumber.endsWith("@c.us")) {
                whatsappNumber = whatsappNumber + "@c.us";
            }
            log("startChat", { whatsappNumber });
            whatsappNumber = this.dialCode + whatsappNumber;
            ChatWatcher.startChatImmediately({
                whatsappNumber,
                channelId: this.channel._id,
                channelType: "whatsapp-v2",
            });
        },
    },
    mounted() {
        this.listChannels().then((channels) => {
            this.channel = channels.find((x) => x._id === this.selectedChannelId);
            this.originalChannel = _.cloneDeep(this.channel);
        });
    },
    watch: {
        channel: {
            handler: function (val) {
                if (val) {
                    const isChanged = !_.isEqual(val, this.originalChannel);
                    if (isChanged) {
                        log("channel changed=>", val);
                        this.handleSave();
                    }
                }
            },
            deep: true,
        },
        currentTab(value) {
            const selected = Object.values(WhatsappV2ChannelMenuTypes).find((x) => x.id === value);
            if (selected) {
                this.$router.push(`/integrations/whatsapp-v2/${this.channel._id}/detail/${selected.path}`);
            }
        },
        type(newValue) {
            const selected = Object.values(this.menuItems).find((x) => x.key === newValue);
            if (selected) {
                this.$router.push(`/integrations/whatsapp-v2/${this.channel._id}/detail/${selected.key}`);
            }
        },
    },
});
</script>

<style scoped lang="scss">
#whatsapp-channel-detail {
    display: flex;
    flex-direction: column;
    background: var(--color-bg-default);
    position: relative;
    width: 100%;
    height: 100%;

    .wrapper {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;

        .toolbar {
            padding: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 50px;
            border: 1px solid var(--color-border-default);

            .left {
                display: flex;
                align-items: center;
                gap: 5px;

                .name {
                    font-size: 18px;
                    font-weight: 700;
                }

                .icon-container {
                    width: 30px;
                    height: 30px;
                    display: flex;
                    margin: 0 auto;
                    align-items: center;
                    justify-content: center;
                    border-radius: 6px;
                    overflow: hidden;
                    position: relative;
                    background: #58ca64;
                    padding: 10px;
                }
            }

            .right {
                display: flex;
                justify-content: flex-end;
                gap: 5px;
            }
        }

        .channel-content {
            display: flex;
            height: 100%;

            .left {
                height: 100%;

                .channel-menu {
                    width: 100%;
                }
            }

            .page-content {
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>
